import { render, staticRenderFns } from "./MobileIcons.vue?vue&type=template&id=fd2070f2&scoped=true&"
import script from "./MobileIcons.vue?vue&type=script&lang=js&"
export * from "./MobileIcons.vue?vue&type=script&lang=js&"
import style0 from "./MobileIcons.vue?vue&type=style&index=0&id=fd2070f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2070f2",
  null
  
)

export default component.exports